import React from 'react';
import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';
import { User, Briefcase } from 'react-feather';

import useAuth from '../../hooks/useAuth';
import { isUserRole, ROLES } from '../../utils/jwt';

const ProfileContainer = styled(Box)`
  background-color: ${(props) => props.theme.sidebar.background};
  padding: ${(props) => props.theme.spacing(3)};
`;

const ProfileCard = styled(Box)`
  border-radius: 12px;
  padding: ${(props) => props.theme.spacing(2.5)};
`;

const InfoRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing(1.5)};
  margin-bottom: ${(props) => props.theme.spacing(1)};
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const IconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
`;

const InfoText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  font-size: 12px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Label = styled(Typography)`
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: ${(props) => props.theme.spacing(0.5)};
`;

const SidebarProfileInfo = () => {
  const { user } = useAuth();
  const role = isUserRole();

  // Only show for customer-portal users.
  if (role !== ROLES.CUSTOMER || !user) {
    return null;
  }

  const getUserDisplayName = () => {
    if (user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`;
    }
    if (user.firstName) {
      return user.firstName;
    }
    if (user.email) {
      return user.email.split('@')[0];
    }
    return 'Användare';
  };

  const displayName = getUserDisplayName();
  const companyName = user.companyName || 'Företag';

  return (
    <ProfileContainer>
      <ProfileCard>
        <Box mb={2}>
          <Label>Inloggad som</Label>
          <InfoRow>
            <IconWrapper>
              <User size={12} color="rgba(255, 255, 255, 0.7)" />
            </IconWrapper>
            <InfoText title={displayName}>{displayName}</InfoText>
          </InfoRow>
        </Box>

        <Box>
          <Label>Företag</Label>
          <InfoRow>
            <IconWrapper>
              <Briefcase size={12} color="rgba(255, 255, 255, 0.7)" />
            </IconWrapper>
            <InfoText title={companyName}>{companyName}</InfoText>
          </InfoRow>
        </Box>
      </ProfileCard>
    </ProfileContainer>
  );
};

export default SidebarProfileInfo;
